import { render, staticRenderFns } from "./ModalUploadUpdateDetails.vue?vue&type=template&id=15b62f64&scoped=true&"
import script from "./ModalUploadUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./ModalUploadUpdateDetails.vue?vue&type=script&lang=js&"
import style0 from "./ModalUploadUpdateDetails.vue?vue&type=style&index=0&id=15b62f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b62f64",
  null
  
)

export default component.exports